import React from "react";
import AlertMessage from "./alert_message";
class LicenseCopyright extends React.Component {

    constructor(props) {
        super(props)
        this.initialState = { query: "", errorMessage: "", showErrorAlert: false, copyright: null }
        this.state = { ...this.initialState }
        this.errorMessages = { emptyField: "Please fill in the field", makeChanges: "Apply changes to the field" }
    }

    closeModelHandler = () => this.setState({ ...this.state, query: this.state.copyright.text })

    resetState = async () => this.setState({ ...this.initialState })

    onChange = (e) => { this.setState({ ...this.state, query: e.target.value }) }

    submitHandler = async (e) => {
        const hasErrors = this.errorHandler()
        if (hasErrors) return
        try {
            await window.meterian.licenses.updateCopyright(this.props.library, this.state.query)
            window.$("#license-copyright-modal .modal-header > button").trigger("click")
            this.setState({ ...this.state, copyright: { ...this.state.copyright, text: this.state.query } })
        } catch (e) {
            this.showErrorAlert(e.message)
        }
    }

    errorHandler = () => {
        if (!this.state.query) {
            this.showErrorAlert(this.errorMessages.emptyField)
            return true
        } else if (this.state.query && this.state.query === this.state.copyright.text) {
            this.showErrorAlert(this.errorMessages.makeChanges)
            return true
        }

        return false
    }

    showErrorAlert = (message) => {
        this.setState({ ...this.state, errorMessage: message, showErrorAlert: true })
        setTimeout(() => {
            this.setState({ ...this.state, errorMessage: "", showErrorAlert: false })
        }, 5000)
    }

    hideErrorAlert = (e) => {
        this.setState({ ...this.state, errorMessage: "", showErrorAlert: false })
    }

    getCopyright = async (library) => {
        try {
            const response = await window.meterian.licenses.getCopyright(library)
            this.setState({ ...this.state, copyright: { ...response }, query: response.text })
        } catch (e) {
            console.log(e)
            this.showErrorAlert(e.message)
        }
    }

    getSnapshotBeforeUpdate(previousProps) {
        return previousProps.library !== this.props.library
    }

    componentDidUpdate(prevProps, prevState, didUpdate) {
        if (!didUpdate) return
        this.resetState()
        this.getCopyright(this.props.library)

    }

    render() {
        const { library } = this.props
        return (
            <div className="modal fade" id="license-copyright-modal" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    {this.state.copyright ?
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">{library ? library.title : ""}</h4>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModelHandler}><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                <h5>Copyright:</h5>
                                <textarea className="col-12" rows="5" cols="100" value={this.state.query} style={{resize: "both"}} onChange={this.onChange}></textarea>
                                {this.state.showErrorAlert ?
                                    <div id="alert-modal">
                                        <div className="alert alert-danger">
                                            <strong><span id="alert-modal-message">{this.state.errorMessage}</span></strong>
                                            <button href="#" className="close" data-hide="alert" onClick={this.hideErrorAlert} style={{ pointerEvents: "all" }}>&times;</button>
                                        </div>
                                    </div> : ""
                                }
                            </div>
                            <div className="modal-footer">
                                <button type="button" data-dismiss="modal" className="btn btn-default" onClick={this.closeModelHandler}>Close</button>
                                <button type="button" className="btn btn-primary" onClick={this.submitHandler}>Confirm</button>
                            </div>
                        </div> :
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">{library ? library.title : ""}</h4>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeModelHandler}><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="modal-body">
                                <div className="center-block d-flex justify-content-center align-items-center">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default LicenseCopyright